import React, { useRef, useEffect } from "react";
import "./Gallery.scss";
import withMotion from "../../Utils/withMotion";
import { withRouter } from "react-router-dom";

//Panels
import { SpeakWithDesigner } from "../../CTA/CTA";
import { TitleBar } from "../../Shapes/Shapes";

//Images
import driveways from "./images/categories/driveways/driveways-banner.jpg";
// import firefeatures from "./images/categories/firefeatures/firefeatures-banner.jpg";
import gardenwalls from "./images/categories/gardenbeds/gardenbeds-banner.jpg";
import patios from "./images/categories/patios/patios-banner.jpg";
import pooldecks from "./images/categories/pooldecks/pooldecks-banner.jpg";
import steps from "./images/categories/steps/steps-banner.jpg";
import walkways from "./images/categories/walkways/walkways-banner.jpg";

//Utils
import { mapServices } from "../../Utils/Utils";

// SEO
import SEO from "../../SEO/index.js";
import StructuredData from "../../SEO/structuredData";

const Gallery = (props) => {
  const projectsRef = useRef(null);

  const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop);

  const { pathname } = props.location;

  useEffect(() => {
    if (pathname.includes("projects")) {
      scrollToRef(projectsRef);
    }
  }, [pathname]);

  const categories = [
    {
      title: "Driveways",
      image: driveways,
      destination: "/gallery/driveways",
    },
    // {
    //   title: "Fire Features",
    //   image: firefeatures,
    //   destination: "/gallery/firefeatures",
    // },
    {
      title: "Garden Walls",
      image: gardenwalls,
      destination: "/gallery/garden-walls",
    },
    {
      title: "Patios",
      image: patios,
      destination: "/gallery/patios",
    },
    {
      title: "Pool Decks",
      image: pooldecks,
      destination: "/gallery/pool-decks",
    },
    {
      title: "Steps & Coping",
      image: steps,
      destination: "/gallery/steps-and-coping",
    },
    {
      title: "Walkways",
      image: walkways,
      destination: "/gallery/walkways",
    },
  ];

  return (
    <>
      <SEO
        title="Completed Paving Projects | Our Gallery | Pacific Pavingstone"
        description="View our gallery of completed pavingstone projects including driveways, patios, pool decks, walkways, and more to gain inspiration for your next project!"
        profileURL={"https://www.pacificpavingstone.com/gallery"}
        type="website"
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org",
          "@type": "ImageGallery",
          name: "Pacific Pavingstone Gallery",
          description: "Paving Projects Completed By Pacific Pavingstone",
          image:
            "https://www.pacificpavingstone.com/static/media/driveways-banner.14cc00a7.jpg",
          URL: "https://www.pacificpavingstone.com/gallery/driveways",
        }}
      />
      <div className="container-fluid">
        <div className="row justify-content-center page-gallery">
          <div className="col-11 col-xl-10">
            <div className="row justify-content-center">
              <div className="col-10 col-sm-8 col-md-6 col-lg-4 mb-2 pb-3 text-center">
                <h1 className="text-uppercase text-blue">Categories</h1>
                <TitleBar />
              </div>
            </div>
            <div className="row justify-content-center services-list">
              {mapServices(categories)}
            </div>
          </div>
        </div>
        <SpeakWithDesigner />
      </div>
    </>
  );
};

export default withRouter(withMotion(Gallery));
